import './styles.css'
import {Modal} from "semantic-ui-react";
import {useSelector, useDispatch} from "react-redux";
import {getLanguage} from "../../../../components/LanguageModal/reducer";
import {useEffect, useState} from "react";
import {editMeet} from "../../actions";

const PopupOrganizer = (props) => {
    const {
        isOpen = false,
        onClose = () => {},
        meet = {},
        venues = [],
        meetsTime = [],
        readMeets = () => {},
        filterData = {},
        token = null,
        t = (key) => key,
    } = props

    const [selectedSlot, setSelectedSlot] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (meet && meet.on_date && meet.on_time && meet.placement && Array.isArray(meetsTime)) {
            const existingSlot = meetsTime.find(slot =>
                slot &&
                slot.on_date === meet.on_date &&
                slot.on_time === meet.on_time &&
                slot.place_code === meet.placement
            );
            if (existingSlot) {
                setSelectedSlot(existingSlot);
            }
        }
    }, [meet, meetsTime]);

    const language = useSelector(getLanguage);
    const languageString = (language) ? language[0] + language[1] : 'en';

    const getUniqueDates = () => {
        const dates = [...new Set(meetsTime.map(slot => slot.on_date))].sort();
        return dates.map(date => {
            const dateObj = new Date(date);
            const options = { day: 'numeric', month: 'long' };
            const display = dateObj.toLocaleDateString('ru-RU', options);
            return {
                id: date,
                date: date,
                display: display
            };
        });
    };

    const getUniqueTimeSlots = () => {
        return [...new Set(meetsTime.map(slot => slot.on_time))].sort();
    };

    const isSlotOccupied = (venue, date, time) => {
        const slots = meetsTime.filter(slot =>
            slot.place_code === venue.name &&
            slot.on_date === date &&
            slot.on_time === time
        );

        // Если есть хотя бы один занятый слот (respondent_exponent !== "0"), считаем занятым
        return slots.some(slot => slot.respondent_exponent !== "0");
    };

    const doesSlotExist = (venue, date, time) => {
        return meetsTime.some(slot =>
            slot.place_code === venue.name &&
            slot.on_date === date &&
            slot.on_time === time
        );
    };

    const isSlotSelected = (venue, date, time) => {
        return selectedSlot &&
            selectedSlot.place_code === venue.name &&
            selectedSlot.on_date === date &&
            selectedSlot.on_time === time;
    };

    const handleSlotSelect = (venue, date, time) => {
        if (isSlotOccupied(venue, date, time)) {
            return;
        }

        const slot = {
            place_code: venue.name,
            on_date: date,
            on_time: time
        };
        setSelectedSlot(slot);
    };

    const isFormValid = () => {
        return !!selectedSlot;
    }

    const handleSave = () => {
        if (!isFormValid() || !selectedSlot) return;

        const params = {
            placement: selectedSlot.place_code || '',
            on_time: selectedSlot.on_time || '',
            on_date: selectedSlot.on_date || '',
        };

        if (meet && meet.id) {
            dispatch(editMeet(token, meet.id, params, t));
            readMeets(1, filterData);
            onClose(false);
        }
    }

    const renderTimeGrid = () => {
        const dates = getUniqueDates();
        const timeSlots = getUniqueTimeSlots();

        if (!venues.length || !dates.length || !timeSlots.length) {
            return (
                <div className="no-data-message">
                    {t('noDataAvailable') || 'Данные недоступны'}
                </div>
            );
        }

        return (
            <div
                className="time-grid-container"
                style={{
                    '--room-count': venues.length
                }}
            >
                {/* Заголовки переговорных */}
                <div className="grid-header">
                    <div className="time-column-header"></div>
                    {venues.map(venue => (
                        <div key={venue.id} className="room-header">
                            {venue.name}
                        </div>
                    ))}
                </div>

                {/* Сетка времени для каждой даты */}
                {dates.map(date => (
                    <div key={date.id} className="date-section">
                        <div className="date-title">
                            {date.display}
                        </div>

                        {timeSlots.map(time => (
                            <div key={`${date.id}-${time}`} className="time-row">
                                <div className="time-label">
                                    {time}
                                </div>
                                {venues.map(venue => {
                                    const isSelected = isSlotSelected(venue, date.date, time);
                                    const isOccupied = isSlotOccupied(venue, date.date, time);
                                    const slotExists = doesSlotExist(venue, date.date, time);

                                    let slotClass = 'time-slot';
                                    if (isSelected) {
                                        slotClass += ' selected';
                                    } else if (isOccupied) {
                                        slotClass += ' occupied';
                                    } else if (slotExists) {
                                        slotClass += ' available';
                                    } else {
                                        slotClass += ' unavailable';
                                    }

                                    return (
                                        <div
                                            key={`${venue.id}-${date.id}-${time}`}
                                            className={slotClass}
                                            onClick={() => !isOccupied && slotExists ? handleSlotSelect(venue, date.date, time) : null}
                                            style={{
                                                cursor: isOccupied || !slotExists ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            {isSelected && (
                                                <div className="selected-indicator">✓</div>
                                            )}
                                            {isOccupied && (
                                                <div className="occupied-indicator">✕</div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        );
    };

    return (
        <Modal
            className='org-modal'
            scrolling
            centered
            open={isOpen}
            onClose={() => onClose(false)}
            closeIcon={true}
        >
            <Modal.Content className='org-modal-content'>
                <h2 className='org-modal-title'>
                    {
                        languageString === 'ru' ?
                            t('meetingOf') + " " +
                            (meet?.initiator_exponent_name || '')
                            + " " + t('meetingAnd') + " " +
                            (meet?.respondent_exponent_name || '')
                            :
                            t('meetingOf') + " " +
                            (meet?.initiator_exponent_name || '')
                            + " " + t('meetingAnd') + " " +
                            (meet?.respondent_exponent_name_en || '')
                    }
                </h2>
                <div className='org-modal-form'>
                    <div className='org-modal-item'>
                        <div className='org-modal-label'>{t('initiator')}</div>
                        <input className='org-modal-input' disabled placeholder={
                            meet?.initiator_exponent_name || ''
                        }/>
                    </div>
                    <div className='org-modal-item'>
                        <div className='org-modal-label'>{t('company')}</div>
                        <input
                            className='org-modal-input'
                            disabled
                            placeholder = {
                                languageString === 'ru' ?
                                    meet?.respondent_exponent_name || ''
                                    :
                                    meet?.respondent_exponent_name_en || ''
                            }
                        />
                    </div>
                    <div className='org-modal-item'>
                        <div className='org-modal-label'>{t('matchmaker')}</div>
                        <input
                            className='org-modal-input'
                            disabled
                            placeholder={
                                languageString === 'ru' ?
                                    meet?.respondent_user_name || ''
                                    :
                                    meet?.respondent_user_name_en || ''
                            }
                        />
                    </div>

                    <div className='org-modal-item time-grid-section'>
                        <div className='org-modal-label'>{t('selectTimeAndPlace')}</div>
                        {renderTimeGrid()}
                    </div>

                    <button
                        className={`org-modal-btn ${isFormValid() ? 'active' : 'disabled'}`}
                        onClick={handleSave}
                        disabled={!isFormValid()}
                    >
                        {t('save')}
                    </button>
                </div>
            </Modal.Content>
        </Modal>
    )
}

export default PopupOrganizer